module.exports = __webpack_public_path__ + "img/icon-login-logo@2x.f7bd94f2.png";